
import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './PerfectStayCTA.css';

class PerfectStayCTA extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hover: false,
    };
  }
  render() {
    return (
      <div className="container mt-4 mb-5">
        <div className="hero-banner-container shadow-lg">
          <div className="hero-overlay d-flex flex-column justify-content-center">
            <div className="container px-5">
              <div className="hero-content">
                <h1 className="hero-title">Ready to Find Your<br />Perfect Stay?</h1>
                <p className="hero-subtitle">
                  Book your stay with verified properties at the best<br />prices.
                </p>
                <div className="d-flex gap-3 mt-4">
                  <button
                    style={{
                      backgroundColor: "#0049b0",
                      color: "#ffffff",
                      border: "1px solid #0049b0",
                      borderRadius: "8px",
                      padding: "12px 24px",
                      fontWeight: 500,
                      fontSize: "1rem",
                      transition: "all 0.3s ease",
                    }}
                  >
                    Book Your Stay <i className="bi bi-arrow-up-right"></i>
                  </button>
                  <button className="btn secondary-action-btn d-flex align-items-center gap-2"
                    style={{
                      backgroundColor: "transparent",
                      color: "#ffffff",
                      border: "1px solid #ffffff",
                      borderRadius: "8px",
                      padding: "12px 24px",
                      fontWeight: 500,
                      fontSize: "1rem",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={() => this.setState({ hover: true })}
                    onMouseLeave={() => this.setState({ hover: false })}
                    style={{
                      backgroundColor: this.state.hover ? "#ffffff" : "transparent",
                      color: this.state.hover ? "#0049b0" : "#ffffff",
                      border: "1px solid #ffffff",
                      borderRadius: "8px",
                      padding: "12px 24px",
                      transition: "all 0.3s ease",
                    }}
                  >
                    Explore Properties <i className="bi bi-arrow-up-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    );
  }
}

export default PerfectStayCTA;
